import { API_ROUTES_FOR_AXIOS } from 'src/constants/ApiRoutes';
import { axiosInstance } from 'src/constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import { UpgradeRequestPayload } from 'src/types/upgradeRequest';
import { handleError } from 'src/utils/commonErrorUtils';

export const sendUpgradeRequest = async (
  body: UpgradeRequestPayload,
): Promise<ApiResponse<string>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['sendUpgradeRequest']();
    const { data } = await axiosInstance.post(apiUrl, body);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
